
import React, { useEffect, useState } from "react";
import "./PurchaseHistory.css";
import { useAuth } from "../../../../../features/auth/AuthContext";
import api from "../../../../../api/api";
import { Grid, Pagination } from "@mui/material";
import { Navigate, useNavigate } from "react-router";

const PurchaseHistory = () => {
   const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();
    const [totalPages, setTotalPages] = useState(0);
    const [nextUrl, setNextUrl] = useState(null);
    const [prevUrl, setPrevUrl] = useState(null);
      const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 12;
      const inial_value = (currentPage - 1) * itemsPerPage;

  const fetchPurchaseHistory = async (page) => {
    try {
      const endpoint = `orders/purchase-history/`;

      const pageNumber = typeof page === "number" ? page : 1;
      const response = await api.get(endpoint, {
                params: {
          page: pageNumber,},
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 200) {
        setRows(response?.data?.data || []);
                setTotalPages(
          response.data.count >= 5
            ? Math.ceil(response.data.count / itemsPerPage)
            : Math.floor(response.data.count / itemsPerPage)
        ); // Calculate total pages
        setNextUrl(response.data.next); // Update next URL
        setPrevUrl(response.data.previous);
      } else {
        setRows([]);
      }
    } catch (error) {
      console.error("Fetching error:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPurchaseHistory(currentPage);
  }, [currentPage]);

    const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const handlesupportticket =()=>{
    navigate("/SupportRequest")
  }


  // hooks/useIsMobile.js (or inline in this file)
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${breakpoint}px)`).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
};

const isMobile = useIsMobile();
// shared helpers
const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "-";
const formatPayment = (p) => (p ? p.charAt(0).toUpperCase() + p.slice(1) : "N/A");
const formatTime = (isoDate) => {
  if (!isoDate) return "-";
  return new Date(isoDate).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
};
const getItemTypeClass = (type) => {
  switch(type?.toLowerCase()) {
    case "course": return "ph-badge-course";
    case "meeting": return "ph-badge-meeting";
    case "practice assignment": return "ph-badge-assignment";
    default: return "ph-badge-default";
  }
};

// DESKTOP: restructured with Item Type badge
const renderDesktopRows = () => (
  <tbody>
    {rows.map((r, i) =>
      r.items.map((item, itemIndex) => (
        <tr
          key={`${i}-${itemIndex}`}
          className={
            r.items.length > 1
              ? itemIndex === 0 ? "ph-order-first" : "ph-order-continued"
              : ""
          }
        >
          <td className="ph-course">
            <div className="ph-item-name">{item?.name || "-"}</div>
          </td>
          <td className="ph-type">
            <span className={`ph-badge ${getItemTypeClass(item?.item_type)}`}>
              {item?.item_type || "-"}
            </span>
          </td>
          {itemIndex === 0 && (
            <td className="ph-muted" rowSpan={r.items.length}>{formatDate(r?.transaction_date)}</td>
          )}
          <td className="ph-muted">{item?.price || "-"}</td>
          {itemIndex === 0 && (
            <>
              <td className="ph-muted" rowSpan={r.items.length}>{formatPayment(r?.payment_type)}</td>
              <td rowSpan={r.items.length}>
                {r?.invoice_link ? (
                  <a className="ph-invoice" href={r.invoice_link} target="_blank" rel="noopener noreferrer">
                    Download Invoice
                  </a>
                ) : (
                  <span className="ph-na">Not Available</span>
                )}
              </td>
            </>
          )}
        </tr>
      ))
    )}
  </tbody>
);

// MOBILE: restructured with Item Type badge
const renderMobileRows = () =>
  rows.map((r, i) => (
    <tbody key={i} className="ph-order-group">
      {r.items.map((item, itemIndex) => (
        <tr key={`${i}-${itemIndex}`}>
          <td data-label="Name" className="ph-course">
            <div className="ph-item-name">{item?.name || "-"}</div>
          </td>
          <td data-label="Type" className="ph-type">
            <span className={`ph-badge ${getItemTypeClass(item?.item_type)}`}>
              {item?.item_type || "-"}
            </span>
          </td>
          {itemIndex === 0 && (
            <td data-label="Date" className="ph-muted ph-shared" rowSpan={r.items.length}>
              {formatDate(r?.transaction_date)}
            </td>
          )}
          <td data-label="Price" className="ph-muted">{item?.price || "-"}</td>
          {itemIndex === 0 && (
            <>
              <td data-label="Payment" className="ph-muted ph-shared" rowSpan={r.items.length}>
                {formatPayment(r?.payment_type)}
              </td>
              <td data-label="Invoice" className="ph-shared" rowSpan={r.items.length}>
                {r?.invoice_link ? (
                  <a className="ph-invoice" href={r.invoice_link} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                ) : (
                  <span className="ph-na">N/A</span>
                )}
              </td>
            </>
          )}
        </tr>
      ))}
    </tbody>
  ));
  return (
    <>
    <div className="ph-card">
      <div className="ph-header" style={{display:"flex",justifyContent:"space-between "}}>
      <h3 className="ph-title">Purchase History</h3>
       <div className="need-help">
          <h4 onClick={handlesupportticket}>Need help?</h4>
        </div>
      </div>

      <div className="ph-tableWrap">
        <table className="ph-table" aria-label="Purchase History">
          <thead>
            <tr>
              <th>Name</th>
              <th className="text-center">Type</th>
              <th>Date</th>
              <th>Total Price</th>
              <th>Payment Type</th>
              <th>Invoice</th>
            </tr>
          </thead>

            {loading ? (
                  <tbody>
              <tr>
                <td colSpan={6} className="ph-empty">Loading...</td>
              </tr>
                  </tbody>

            ) : rows.length ? (

    isMobile ? renderMobileRows() : renderDesktopRows()







//               rows.map((r, i) => {
//   const dateStr = r?.transaction_date
//     ? new Date(r.transaction_date).toLocaleDateString("en-GB", {
//         day: "2-digit", month: "short", year: "numeric",
//       })
//     : "-";

//   const paymentType = r?.payment_type
//     ? r.payment_type.charAt(0).toUpperCase() + r.payment_type.slice(1)
//     : "N/A";

//   return r.items.map((item, itemIndex) => (
//     // <tr key={`${i}-${itemIndex}`}   className={itemIndex === 0 && r.items.length > 1 ? "ph-order-first" : ""}
//     <tr 
//   key={`${i}-${itemIndex}`}
//   className={
//     r.items.length > 1
//       ? itemIndex === 0
//         ? "ph-order-first"
//         : "ph-order-continued"
//       : ""
//   }
// >

//       <td data-label="Course Name" className="ph-course">
//         {item?.name || "-"}
//       </td>

//       <td data-label="Total Price" className="ph-muted">
//         {item?.price || "-"}
//       </td>

//       {/* Render shared columns only on the FIRST item row */}
//       {itemIndex === 0 && (
//         <>
//           <td data-label="Date" className="ph-muted" rowSpan={r.items.length}>
//             {dateStr}
//           </td>

//           <td data-label="Payment Type" className="ph-muted" rowSpan={r.items.length}>
//             {paymentType}
//           </td>

//           <td data-label="Invoice" rowSpan={r.items.length}>
//             {r?.invoice_link ? (
//               <a className="ph-invoice" href={r.invoice_link}
//                 target="_blank" rel="noopener noreferrer">
//                 Download Invoice
//               </a>
//             ) : (
//               <span className="ph-na">Not Available</span>
//             )}
//           </td>
//         </>
//       )}
//     </tr>
//   ));
// })







//for mobile responsive


// rows.map((r, i) => {
//   const dateStr = r?.transaction_date
//     ? new Date(r.transaction_date).toLocaleDateString("en-GB", {
//         day: "2-digit", month: "short", year: "numeric",
//       })
//     : "-";
//   const paymentType = r?.payment_type
//     ? r.payment_type.charAt(0).toUpperCase() + r.payment_type.slice(1)
//     : "N/A";

//   return (
//     <tbody key={i} className="ph-order-group">
//       {r.items.map((item, itemIndex) => (
//         <tr key={`${i}-${itemIndex}`}>
//           <td data-label="Course Name" className="ph-course">
//             {item?.name || "-"}
//           </td>
//           <td data-label="Total Price" className="ph-muted">
//             {item?.price || "-"}
//           </td>
//           {itemIndex === 0 && (
//             <>
//               <td data-label="Date" className="ph-muted ph-shared" rowSpan={r.items.length}>
//                 {dateStr}
//               </td>
//               <td data-label="Payment Type" className="ph-muted ph-shared" rowSpan={r.items.length}>
//                 {paymentType}
//               </td>
//               <td data-label="Invoice" className="ph-shared" rowSpan={r.items.length}>
//                 {r?.invoice_link ? (
//                   <a className="ph-invoice" href={r.invoice_link} target="_blank" rel="noopener noreferrer">
//                     Download Invoice
//                   </a>
//                 ) : (
//                   <span className="ph-na">Not Available</span>
//                 )}
//               </td>
//             </>
//           )}
//         </tr>
//       ))}
//     </tbody>
//   );
// })










            ) : (
                  <tbody>
              <tr>
                <td colSpan={6} className="ph-empty">
                  No purchases found.
                </td>
              </tr>
                  </tbody>

            )}
        </table>
      </div>
    </div>
              <div className="purchase-pagination">
                <Grid xs={12} container justifyContent={"center"}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    hideNextButton={nextUrl === null || currentPage === totalPages} // Disable if no next URL and on the last page
                    hidePrevButton={prevUrl === null || currentPage === 1} // Hide if no previous URL and on the first page
                  />
                </Grid>
              </div>
    </>
  );
};

export default PurchaseHistory;